import { MutateCellForm } from "@dmca/frontend/widgets/admin";
import { createFileRoute } from "@tanstack/react-router";
import { object, optional, string } from "valibot";

export const Route = createFileRoute(
  "/_authed/_drawerLayout/admin/cell/add-new"
)({
  component: RouteComponent,
  validateSearch: object({
    plantId: optional(string()),
  }),
  loader: ({ context: { trpcQcProxy: trpc, qc } }) => {
    qc.prefetchQuery(trpc.plant.getAll.queryOptions());
  },
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { plantId } = Route.useSearch();
  return (
    <MutateCellForm
      type="add"
      initialPlantId={plantId}
      onSuccess={(cell) => {
        navigate({ to: "/admin/cell/$id", params: { id: cell.id } });
      }}
    />
  );
}
